import { Button } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const DropdownWrapperStyled = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 auto;
  padding: 1rem 0 8rem;
`;

export const DropdownButtonStyled = styled(Button)`
  font-weight: 700;
  height: 3.8rem;
  padding: 0 1rem;
  font-size: 1.6rem;
  line-height: 2.6rem;
`;
